import { EColors, EFont } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledPicture = styled.img`
  width: 100%;
  height: 100%;
  @media screen and (min-width: 1000px) {
    height: 776px;
  }
`;
export const ButtonWrapper = styled.div`
  @media screen and (min-width: 450px) and (max-width: 999px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const StyledTitlePhone = styled(Styled.PBody1SB)`
  margin-top: 36px;
  margin-bottom: 20px;
`;
export const StyledPhonesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 449px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;
export const StyledLinkPhone = styled.a`
  text-decoration: none;
  font-family: ${EFont.Fira_Sans};
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: ${EColors.accent_300};
`;
